module.exports = __webpack_public_path__ + "img/08.c7bbd88c.png";